import { Component, OnInit } from '@angular/core';
import {UserModel} from '../../models/authentication/user.model';
import {CountryModel} from '../../models/localization-and-pricing/country.model';
import {AdminSelectCountryService} from '../shared/admin-select-country/admin-select-country.service';
import {MobileMenuService} from '../../mobile/mobile-menu/mobile-menu.service';

@Component({
  selector: 'app-evo-admin-header',
  templateUrl: './evo-admin-header.component.html',
  styleUrls: ['./evo-admin-header.component.css']
})
export class EvoAdminHeaderComponent implements OnInit {

  hideHamburgerIcon = false;
  CountryModel = CountryModel;

  constructor(public mobileMenuSv: MobileMenuService,
              public selectCountrySv: AdminSelectCountryService) { }

  ngOnInit() {
  }

  onMobileMenuClicked() {

    if (this.mobileMenuSv.isVisible === true) {
      this.mobileMenuSv.isVisible = false;
    } else {
      this.mobileMenuSv.isVisible = true;
    }

  }

  navigateHome() {

  }

  getCountryFlag(): string {

    return CountryModel.iconURL(UserModel.getAdminCountry());
  }

  getCurrentCountryTitle(): string {

    return CountryModel.title(UserModel.getAdminCountry());

  }

  onSelectCountry() {

    this.selectCountrySv.show(UserModel.getAdminCountry()).subscribe((country) => {
      UserModel.setAdminCountry(country);
      this.selectCountrySv.countryChanged$.next(country);
    });

  }

}
